import { PumpTimelineMessages, TranslationPumpTimelineMessages } from "../interfaces";

export const messages: TranslationPumpTimelineMessages = {
  [PumpTimelineMessages.state]: "Estado",
  [PumpTimelineMessages.destination]: "Destino",
  [PumpTimelineMessages.driver]: "Conductor",
  [PumpTimelineMessages.tooltipSpeedThreshold]: "Velocidad máxima: ",
  [PumpTimelineMessages.tooltipGenerateAt]: "Generado"
};
